import lottie from "lottie-web";
import LottieScene from "./LottieScene";

export const faqAnim = container => {
  // const limitFps = false; // limit to AfterEffects fps (eg 30fps)
  // const cross = new LottieScene(
  //   document.querySelector('[data-scene="cross"]'),
  //   limitFps,
  //   false,
  //   false,
  //   false
  // );
  // cross.init(false);
  // cross.loopBetween([1, 120], false);
  //   anims.push(lighter);

  var animation = lottie.loadAnimation({
    container: container, // Required
    path: "../static/animations/expand_collaps.json", // Required
    renderer: "svg", // Required
    loop: false, // Optional
    autoplay: false // Optional
  });
  return animation;
};

export default faqAnim;
